﻿"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class PasswordLocalizedTextUtil {
}
exports.PasswordLocalizedTextUtil = PasswordLocalizedTextUtil;
PasswordLocalizedTextUtil.getNewPasswordFieldsTexts = (translate) => {
    return {
        lengthError: translate('ErrorMinLength'),
        shouldContainLowerCaseError: translate('ErrorPassword_ShouldContainLowercase'),
        shouldContainUpperCaseError: translate('ErrorPassword_ShouldContainUppercase'),
        shouldContainNonAlphanumericError: translate('ErrorPassword_ShouldContainNonAlphanumeric'),
        shouldNotContainUserNameError: translate('ErrorPassword_ContainsUserName'),
        confirmationError: translate('ErrorConfirmationPassword'),
        requiredFieldError: translate('ErrorRequiredField'),
        password: translate('Password'),
        confirmPassword: translate('ConfirmPassword')
    };
};
PasswordLocalizedTextUtil.getUpdatePasswordFieldsTexts = (translate) => {
    let passwordFieldTexts = PasswordLocalizedTextUtil.getNewPasswordFieldsTexts(translate);
    return Object.assign(Object.assign({}, passwordFieldTexts), { currentPassword: translate('CurrentPassword') });
};
//# sourceMappingURL=PasswordLocalizedTextUtil.js.map